import i18n from '@opsbase/lib-i18n';
import { NiceDateFormat } from '@opsbase/lib-time/consts';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
export function TimestampsOverviewSection(props) {
    const { opDefinition, className } = props;
    return (React.createElement(Horizontal, { classes: { root: className }, padding: true, gutter: true, justify: "space-between" },
        React.createElement(Pane, null,
            React.createElement(Text, { variant: "h2" }, i18n.t('created') + ': ' + opDefinition.createdDate.format(NiceDateFormat))),
        React.createElement(Pane, null,
            React.createElement(Text, { variant: "h2" }, i18n.t('updated') + ': ' + opDefinition.updatedDate.format(NiceDateFormat)))));
}
export default TimestampsOverviewSection;
